import { handleRequest } from "../utilities/requestHandler";

export const registerUser = (req_body) =>
    handleRequest("post","/auth/register",req_body);